/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";

import { ComplianceTest } from "common/contexts";

import Img from "components/atoms/Img";
import Toast from "components/atoms/Toast/index";

import QuizSection from "./QuizSection/index";
import StartForm from "./StartForm";

import style from "./Index.module.scss";

function ComplianceGuideTool({ data, dataComplianceTest, dataQuestion }) {
  const [dataTest, setDataTest] = useState();
  const [firstScreen, setFirstScreen] = useState(true);
  const [step, setStep] = useState(0);
  const [stepIndex, setStepIndex] = useState(0);
  const [country, setCountry] = useState("");
  const [entityType, setEntityType] = useState([]);
  const [entityTypeSelect, setEntityTypeSelect] = useState([]);
  const [questionData, setQuestionData] = useState({});
  const [questionIndex, setQuestionIndex] = useState(0);
  const [childrenShow, setChildrenShow] = useState(false);
  const [fromChildren, setFromChildren] = useState(false);
  const [dataCompliance, setDataCompliance] = useState([]);
  const [dataChildren, setDataChildren] = useState([]);
  const [userData, setUserData] = useState();

  useEffect(() => {
    if (country && country != "") {
      const arrEntity = [];

      data
        .find((countryQuestion) => countryQuestion.id == country?.value)
        ?.EntityTypes?.forEach((type) => {
          arrEntity.push({ label: type.name, value: type.id });
        });
      setEntityTypeSelect(arrEntity);
    }
  }, [country]);
  useEffect(() => {
    if (entityType) {
      setDataTest(
        dataQuestion
          .find((countryQuestion) => countryQuestion.id == country?.value)
          ?.type?.find((entity) => entity.id === entityType)
      );
    }
  }, [entityType]);
  // UseEffect(() => {
  //   // If (reloadMode) {
  //   //   If (!backMode && !firstScreen) {
  //   //     If (stepIndex == 0) {
  //   //     }
  //   //   }
  //   // }
  //   SetReloadMode(true);
  // }, [step, stepIndex, subStepIndex, firstScreen]);

  function reset() {
    setStepIndex(0);
    setFirstScreen(true);
    setCountry(null);
    setUserData(null);
    setDataCompliance([]);
    setStep(0);
    setQuestionData({});
    setQuestionIndex(0);
    setChildrenShow(false);
    setDataChildren([]);
    setFromChildren();
    setEntityType(null);
    setEntityTypeSelect(null);
  }

  return (
    <ComplianceTest.Provider
      value={{
        stepIndex,
        setStepIndex,
        setFirstScreen,
        setCountry,
        userData,
        setUserData,
        dataCompliance,
        setDataCompliance,
        step,
        setStep,
        questionData,
        setQuestionData,
        questionIndex,
        setQuestionIndex,
        childrenShow,
        setChildrenShow,
        dataChildren,
        setDataChildren,
        fromChildren,
        setFromChildren,
        entityType,
        setEntityType,
        data: dataTest,
        country,
        reset,
      }}
    >
      <div className="mt-20 py-6 lg:mt-24 lg:pt-24 lg:pb-0">
        <div className="container">
          {firstScreen ? (
            <div className={style.MainContent}>
              <div className={"row flex-col-reverse lg:flex-row"}>
                <div className="lg:col-6">
                  <Toast>
                    <StartForm
                      data={{
                        ...dataComplianceTest,
                        entityData: data,
                      }}
                      entity={entityTypeSelect}
                    />
                  </Toast>
                </div>
                <div className="flex items-center justify-center lg:col-6">
                  <div className="">
                    <Img
                      className="w-100"
                      loading={"eager"}
                      alt="icon-build"
                      src="/assets/images/offshore/guide-and-tool/annual_compliance_guide-offshore-tools.png"
                      style={{ objectFit: "contain" }}
                      width={540}
                      height={409}
                    />
                  </div>
                </div>
              </div>
              <div
                className="mt-10 lg:mt-20"
                dangerouslySetInnerHTML={{
                  __html: dataComplianceTest.disclaimer,
                }}
              ></div>
            </div>
          ) : (
            <div>
              <QuizSection country={country} data={dataTest} />
            </div>
          )}
        </div>
      </div>
    </ComplianceTest.Provider>
  );
}
export default function ComplianceSelfAssessmentTest({
  data,
  dataComplianceTest,
  dataQuestion,
}) {
  return (
    <Toast>
      <ComplianceGuideTool
        data={data}
        dataComplianceTest={dataComplianceTest}
        dataQuestion={dataQuestion}
      />
    </Toast>
  );
}
